import { useState } from "react";
import { useModuloInfo } from "../../Context/ModuloInfo";
import Table from "../Table";
import { ColumnDescription } from "react-bootstrap-table-next";
import {
    IListagemDasPesquisasSatisfacaoRelatorios,
    IListarPesquisaSatisfacao,
} from "../../Interfaces/HelpDesk/GestaoRespostas/GestaoRespostasInterface";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import useAsyncEffect from "../../hooks/useAsyncEffect";
import {
    GerarRelatorioPesquisaSatisfacaoHelpdeskController,
    ListarPesquisaSatisfacaoController,
} from "../../Controllers/HelpDesk/GestaoRespostas/GestaoRespostasControllers";
import { IComponentModal } from "../Modais/IModalComponent";
import ModalComponent from "../Modais";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ModalVisualizarPesquisaSatisfacao from "../../Pages/HelpDesk/PesquisaSatisfacao/ModalVisualizarPesquisaSatisfacao";
import { formatedTelefone } from "../../Tools/FormatTools";
import usePaginationFilter from "../../hooks/usePaginationFilter";
import { ACESSOS } from "../../Routes/Acessos";
import FiltroPesquisaSatisfacao from "./FiltroPesquisaSatisfacao";
import ExportExcel from "../StickyToolbar/ExportExcel";

const todaysDate = new Date();
//instancia um objeto date de 3 meses antes da data de hoje
const pastDate = new Date(new Date().setMonth(todaysDate.getMonth() - 3));
const filtroInicial: IListarPesquisaSatisfacao = {
    DS_NOME: "",
    ID_CASO: undefined,
    ID_FORMULARIO: undefined,
    ID_USUARIO: undefined,
    NR_TELEFONE: "",
    PAGINA: 1,
    QUANTIDADE: 10,
    ID_EMPREENDIMENTOS: undefined,
    ID_UNIDADES: undefined,
    DT_INICIAL: pastDate.toISOString().substring(0, 10),
    DT_FINAL: todaysDate.toISOString().substring(0, 10),
};

export default function PesquisaSatisfacao() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const { id } = useModuloInfo();

    const { PageFilter, setPage, filter, setFilter } =
        usePaginationFilter<IListarPesquisaSatisfacao>({
            page: 1,
        });

    const FILTRO_PESQUISA_SATISFACAO_HELPDESK_ID_MODULO =
        sessionStorage.getItem(`FILTRO_PESQUISA_SATISFACAO_HELPDESK_${id}`);

    const isHelpDesk = ACESSOS.HELPDESK.ID_MODULO === id;

    const {
        value: lstPesquisaSatisfacao,
        loading: lstPesquisaSatisfacaoLoading,
    } = useAsyncEffect(async () => {
        if (!id) return;

        return ListarPesquisaSatisfacaoController(
            {
                ...filter,
                PAGINA: PageFilter.page,
                QUANTIDADE: 10,
                ID_CASO: isHelpDesk
                    ? undefined
                    : filter?.ID_CASO
                    ? filter?.ID_CASO
                    : undefined,
                ID_CONTA_CHAT:
                    isHelpDesk && filter?.ID_CASO ? filter?.ID_CASO : undefined,
                ID_EMPREENDIMENTOS:
                    filter?.ID_EMPREENDIMENTOS &&
                    filter?.ID_EMPREENDIMENTOS.toString().length > 0
                        ? (filter?.ID_EMPREENDIMENTOS as any)?.map(String)
                        : undefined,
                ID_UNIDADES:
                    filter?.ID_UNIDADES &&
                    filter?.ID_UNIDADES.toString().length > 0
                        ? (filter?.ID_UNIDADES as any)?.map(String)
                        : undefined,
                DS_EMAIL: filter?.DS_EMAIL ? filter?.DS_EMAIL : undefined,
                DS_NOME: filter?.DS_NOME ? filter?.DS_NOME : undefined,
                DT_FINAL: filter?.DT_FINAL ? filter?.DT_FINAL : undefined,
                DT_INICIAL: filter?.DT_INICIAL ? filter?.DT_INICIAL : undefined,
                NR_TELEFONE: filter?.NR_TELEFONE
                    ? filter?.NR_TELEFONE
                    : undefined,
            },
            id
        );
    }, [PageFilter, id, filter]);

    const tableviewColumns: Array<
        ColumnDescription<IListagemDasPesquisasSatisfacaoRelatorios>
    > = [
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (c, row) => {
                return (
                    <>
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="ver-atendimento-tooltip">
                                    Ver Pesquisa
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-outline-info font-weight-bold mr-2"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent: `Visualizar Pesquisa Satisfação`,
                                        IconHeader: faEye,
                                        Component: () => (
                                            <ModalVisualizarPesquisaSatisfacao
                                                idContaChat={row.ID_CONTA_CHAT}
                                                visualizandoFormRespondido={
                                                    true
                                                }
                                                setShow={setShow}
                                                idFormulario={row.ID_FORMULARIO}
                                                lstPesquisaSatisfacao={row}
                                                idCaso={row.ID_CASO}
                                            />
                                        ),
                                        size: "lg",
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faEye} size="lg" />
                            </button>
                        </OverlayTrigger>
                    </>
                );
            },
        },
        {
            dataField: `${
                ACESSOS.HELPDESK.ID_MODULO === id ? "ID_CONTA_CHAT" : "ID_CASO"
            }`,
            text: `Protocolo`,
        },
        {
            dataField: "DS_FORMULARIO",
            text: `Formulário`,
        },
        {
            dataField: "DS_NOME",
            text: `Nome`,
        },
        {
            dataField: "NR_TELEFONE",
            text: `Telefone`,
            formatter: (c) => (c ? formatedTelefone(c) : "-"),
        },
        {
            dataField: "DS_NOME_ATENDENTE",
            text: `Nome Atendente`,
            formatter: (c) => (c ? c : "-"),
        },
        {
            dataField: "DT_ASSINATURA",
            text: `Dt. Resposta Pesquisa`,
            formatter: (c) => (c ? new Date(c).toLocaleDateString() : "-"),
        },
    ];

    return (
        <>
            <div className="card">
                <Table
                    data={lstPesquisaSatisfacao?.Relatorios ?? []}
                    loading={lstPesquisaSatisfacaoLoading}
                    columns={tableviewColumns}
                    keyField="ID"
                    noDataIndication={() => (
                        <div className="text-black-50 text-center">
                            Nenhuma Pesquisa de Satisfação encontrada
                        </div>
                    )}
                    tableView={{
                        columns: tableviewColumns,
                        sizePerPage: 10,
                        cancelYScroll: true,
                        defaultStyle: true,
                        striped: true,
                    }}
                    bordered={false}
                    defaultStyle={{ align: "center" }}
                    striped={false}
                    rowClasses={"rowClasses"}
                    rowStyle={{ height: 60 }}
                    noSearch
                    totalPages={lstPesquisaSatisfacao?.NR_PAGINAS ?? 0}
                    onTableChange={(type, newState) => {
                        setPage(newState.page);
                    }}
                    remote={{ pagination: true }}
                />
            </div>
            <FiltroPesquisaSatisfacao
                FILTRO_PESQUISA_SATISFACAO_HELPDESK_ID_MODULO={
                    FILTRO_PESQUISA_SATISFACAO_HELPDESK_ID_MODULO
                }
                filtroInicial={filtroInicial}
                setFilter={setFilter}
            />

            <ExportExcel
                baixarExcelController={async () => {
                    return GerarRelatorioPesquisaSatisfacaoHelpdeskController(
                        {
                            ...filter,
                            PAGINA: 0,
                            QUANTIDADE: 10,
                            ID_CASO: isHelpDesk
                                ? undefined
                                : filter?.ID_CASO
                                ? filter?.ID_CASO
                                : undefined,
                            ID_CONTA_CHAT:
                                isHelpDesk && filter?.ID_CASO
                                    ? filter?.ID_CASO
                                    : undefined,
                            ID_EMPREENDIMENTOS:
                                filter?.ID_EMPREENDIMENTOS &&
                                filter?.ID_EMPREENDIMENTOS.toString().length > 0
                                    ? (filter?.ID_EMPREENDIMENTOS as any)?.map(
                                          String
                                      )
                                    : undefined,
                            ID_UNIDADES:
                                filter?.ID_UNIDADES &&
                                filter?.ID_UNIDADES.toString().length > 0
                                    ? (filter?.ID_UNIDADES as any)?.map(String)
                                    : undefined,
                            DS_EMAIL: filter?.DS_EMAIL
                                ? filter?.DS_EMAIL
                                : undefined,
                            DS_NOME: filter?.DS_NOME
                                ? filter?.DS_NOME
                                : undefined,
                            DT_FINAL: filter?.DT_FINAL
                                ? filter?.DT_FINAL
                                : undefined,
                            DT_INICIAL: filter?.DT_INICIAL
                                ? filter?.DT_INICIAL
                                : undefined,
                            NR_TELEFONE: filter?.NR_TELEFONE
                                ? filter?.NR_TELEFONE
                                : undefined,
                        },
                        id ?? 0
                    );
                }}
                nomeArquivo={"Pesquisa_Satisfacao"}
            />

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
